import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

import { QualtricsSurveys } from '@fcom/common/qualtrics/qualtrics.utils';
import { FeedbackService } from '@fcom/common/services/feedback/feedback.service';

@Component({
  selector: 'fin-corporate-routing',
  templateUrl: './corporate-routing.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CorporateRoutingComponent implements OnInit {
  constructor(private feedbackService: FeedbackService) {}

  ngOnInit(): void {
    this.feedbackService.setSurvey(QualtricsSurveys.CORPORATE_FEEDBACK);
  }
}
